import { myAxios } from "../utils/serverContextPath";

// =======================================================
// CRUD
// =======================================================

export const postMessage = (data) => {
    return myAxios.post("message/save/insert", data);
    
};

export const updateMessage = (data) => {
    return myAxios.post("message/save/update", data);
};

export const getMessageById = (id) => {
    return myAxios.get(`message/getbyid/${id}`);
};

export const getMessageAllPage = (
    keyword = "",
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("message/getallpage", {
        params: {
            keyword,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};

export const getAllMessage = (
    keyword = "",
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("message/getall", {
        params: {
            keyword,
            sortList,
            sortOrder
        }
    });

};

export const deleteMessage = (id) => {
    return myAxios.delete(`message/delete/${id}`);
};

// =======================================================
// Recherche
// =======================================================

export const findSimilarMessage = (
    keyword,
    tauxsimilarity = 0.6,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("message/similarity", {
        params: {
            keyword,
            tauxsimilarity,
            sortList,
            sortOrder
        }
    });

};

// =======================================================
// Métier
// =======================================================

export const getMessageByConsultationRequestId = (
    consultationRequestId,
    sortList = [],
    sortOrder = "ASC"
) => {

    return myAxios.get(
        `message/getallbyconsultationrequest/${consultationRequestId}`,
        {
            params: {
                sortList,
                sortOrder
            }
        }
    );

};



export const uploadFileToMessage = (id,index,formData) => {
    return myAxios.post(
        `message/uploadfile/${id}/${index}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const downloadFileFromMessage = (id,index) => {
    return myAxios.get(`message/downloadfile/${id}/${index}`, {
        responseType: "blob",
    });

};